import React from 'react';
import { PublicHero, PublicCTAGroup } from '@/components/public';
import { IMAGES } from '@/config/brand';
import LeadCaptureForm from './LeadCaptureForm';

const BACKGROUND_IMAGE = {
  src: IMAGES.JOIN.OWNER_WITH_TABLET,
  alt: 'Independent Canadian business owner working in their local shop',
  overlay: 'strong',
};

const scrollTo = (id) => (e) => {
  if (e) e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const PRIMARY_CTA = {
  label: 'Calculate Savings',
  onClick: scrollTo('roi-calculator'),
  testId: 'hero-calculate-savings-btn',
};

const SECONDARY_CTA = {
  label: 'View Packages',
  href: '#pricing',
  external: false,
  onClick: scrollTo('pricing'),
  testId: 'hero-view-packages-btn',
};

export default function HeroSection() {
  return (
    <div id="lead-form-anchor">
      <PublicHero
        wrapperAs="header"
        eyebrow="Built in Alberta, for Western Canada"
        title={
          <>
            Stop paying{' '}
            <span className="text-primary drop-shadow-[0_2px_18px_hsl(var(--primary)/0.45)]">
              30%
            </span>{' '}
            commissions just to reach your own local customers.
          </>
        }
        description="A flat-rate, 0% commission delivery platform built for independent restaurants, cafes, and local retailers who want to keep what they earn."
        backgroundImage={BACKGROUND_IMAGE}
        actions={<PublicCTAGroup primary={PRIMARY_CTA} secondary={SECONDARY_CTA} />}
        media={<LeadCaptureForm />}
        testId="join-hero"
      />
    </div>
  );
}
